import React, { useState } from "react";
import businessBlue from "../../assets/images/icons/png/business-blue.png";
import businessWhite from "../../assets/images/icons/png/business-white.png";
import servicesBlue from "../../assets/images/icons/png/services-blue.png";
import servicesWhite from "../../assets/images/icons/png/services-white.png";
import dashboardBlue from "../../assets/images/icons/png/dashboard-blue.png";
import dashboardWhite from "../../assets/images/icons/png/dashboard-white.png";
import helpBlue from "../../assets/images/icons/png/help-blue.png";
import helpWhite from "../../assets/images/icons/png/help-white.png";
import iconImage from "../../assets/images/brand-logo.png";
import { NavLink } from "react-router-dom";
import styled from "@emotion/styled";
import { HorizontalGap } from "../styled/gaps";

const navLinksData = [
  {
    label: "Dashboard",
    to: "/dashboard",
    icon: dashboardWhite,
    iconA: dashboardBlue,
  },
  {
    label: "Services",
    to: "/services",
    icon: servicesWhite,
    iconA: servicesBlue,
  },
  {
    label: "Business",
    to: "/business/profile",
    icon: businessWhite,
    iconA: businessBlue,
  },
  {
    label: "Help",
    to: "/help",
    icon: helpWhite,
    iconA: helpBlue,
  },
];

const NavLinksContainer = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
`;

const SingleLink = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 20px;
  a {
    text-decoration: none;
    color: #fff;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    font-family: Roboto;
  }
`;

const StyledLink = styled(NavLink)`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 20px;
  text-decoration: none;
  color: #fff;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  font-family: Roboto;
  padding-left: 20px;
  width: 80%;
  height: 40px;
  border-radius: 10px;
  img.img-active {
    display: none;
  }
  &.active {
    background-color: white;
    color: #002979;
    img.img-inactive {
      display: none;
    }
    img.img-active {
      display: block;
    }
  }
`;

const NavLinks = (props) => {
  const [isHover, SetIsHover] = useState(false);
  return (
    <NavLinksContainer>
      {navLinksData.map((linkData, idx) => {
        return (
          <StyledLink key={idx} to={linkData.to}>
            <img className="img-inactive" src={linkData.icon} width={"20px"} />
            <img className="img-active" src={linkData.iconA} width={"20px"} />
            <HorizontalGap size={"10px"} />
            <div>{linkData.label}</div>
          </StyledLink>
        );
      })}
    </NavLinksContainer>
  );
};

export { NavLinks };
